export const useTabList = ["PAYMENT", "JOURNAL", "LOGBOOK", "OTHERS"]